import { render, staticRenderFns } from "./warningList.vue?vue&type=template&id=d4537a5c&scoped=true"
import script from "./warningList.vue?vue&type=script&lang=js"
export * from "./warningList.vue?vue&type=script&lang=js"
import style0 from "./warningList.vue?vue&type=style&index=0&id=d4537a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4537a5c",
  null
  
)

export default component.exports